import { Component, OnInit } from '@angular/core';
import { MainAppService } from 'src/app/services/main-app.service';

@Component({
  selector: 'app-reports-main',
  templateUrl: './reports-main.component.html',
  styleUrls: ['./reports-main.component.css']
})
export class ReportsMainComponent implements OnInit {

  isSuperAdmin: boolean = false;

  constructor(public mainAppService: MainAppService) { }

  ngOnInit(): void {
    this.mainAppService.user().subscribe(isSuperAdmin => {
      this.isSuperAdmin = isSuperAdmin;
    });
  }

}
